export default () => ({
  avatarAV: {
    backgroundColor: 'green',
    color: 'white',
    margin: 0,
    marginRight: 3,
    width: 30,
    height: 30,
    fontSize: 16,
  },
  avatarUN: {
    backgroundColor: 'red',
    color: 'white',
    margin: 0,
    marginRight: 3,
    width: 30,
    height: 30,
    fontSize: 16,
  },
  avatarUR: {
    backgroundColor: 'purple',
    color: 'white',
    margin: 0,
    marginRight: 3,
    width: 30,
    height: 30,
    fontSize: 16,
  },
  tooltip: {
    textAlign: 'center',
  },
  icon: {
    padding: 0,
    marginRight: 3,
    color: 'green',
  },
  marginAV: {
    margin: 5,
    color: 'green',
  },
  marginUN: {
    margin: 5,
    color: 'red',
  },
  marginUR: {
    margin: 5,
    color: 'purple',
  },
});



// WEBPACK FOOTER //
// ./src/screens/private/Schedules/components/TimeCountLabel.styles.js